import styled from "styled-components";
import themeGet from "@styled-system/theme-get";

const Paragraph = styled.p`
  margin: 0 0 ${themeGet("space.3")};
`;

export default Paragraph;
